import React from 'react';
import _ from 'lodash';

import SortableHeaderCell from 'components/SortableHeaderCell';
import NotEqualIcon from 'icons/NotEqualIcon';

const OptionCell = ({data, column, meet, style}) => {
  const lifter = data;
  if(lifter.row === 'header') {
    return (<SortableHeaderCell style={style} column={column}/>);
  } else {
    const option = _.find(column.options(data, meet), {value: _.get(lifter, column.key)});
    const match = _.get(lifter, ['match', column.key]);
    return (
      <div style={style} className="table-cell-inner ellipsis">
        { _.get(option, 'label') }
        { !match && <div className="mismatch-icon-wrapper"><NotEqualIcon /></div> }
      </div>
    );
  }
};

export default OptionCell;
